import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import { Analytics } from './components/Analytics';
import Home from './pages/Home';
import JsonFormatter from './pages/tools/JsonFormatter';
import Base64Tool from './pages/tools/Base64Tool';
import UuidGenerator from './pages/tools/UuidGenerator';
import HashGenerator from './pages/tools/HashGenerator';
import UrlEncoder from './pages/tools/UrlEncoder';
import TimestampConverter from './pages/tools/TimestampConverter';
import ColorConverter from './pages/tools/ColorConverter';
import JwtDecoder from './pages/tools/JwtDecoder';
import RegexTester from './pages/tools/RegexTester';
import MarkdownPreview from './pages/tools/MarkdownPreview';
import QRCodeGenerator from './pages/tools/QRCodeGenerator';
import LoremIpsumGenerator from './pages/tools/LoremIpsumGenerator';
import HTMLEntityEncoder from './pages/tools/HTMLEntityEncoder';

function App() {
    return (
        <>
            <Analytics />
            <Routes>
            <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="json-formatter" element={<JsonFormatter />} />
                <Route path="base64" element={<Base64Tool />} />
                <Route path="uuid-generator" element={<UuidGenerator />} />
                <Route path="hash-generator" element={<HashGenerator />} />
                <Route path="url-encoder" element={<UrlEncoder />} />
                <Route path="timestamp-converter" element={<TimestampConverter />} />
                <Route path="color-converter" element={<ColorConverter />} />
                <Route path="jwt-decoder" element={<JwtDecoder />} />
                <Route path="regex-tester" element={<RegexTester />} />
                <Route path="markdown-preview" element={<MarkdownPreview />} />
                <Route path="qr-code-generator" element={<QRCodeGenerator />} />
                <Route path="lorem-ipsum-generator" element={<LoremIpsumGenerator />} />
                <Route path="html-entity-encoder" element={<HTMLEntityEncoder />} />
            </Route>
        </Routes>
        </>
    );
}

export default App;